import { Link } from "react-router-dom";
import { scrollToSection } from "@/App";
import { openCookieSettings } from "@/components/CookieConsent";

const NAV = [
  { label: "Forside", to: "/" },
  { label: "Vi tilbyder", to: "/vi-tilbyder" },
  { label: "Viden", to: "/viden" },
  { label: "Ressourcer", to: "/ressourcer" },
  { label: "Om os", to: "/om-os" },
  { label: "Kontakt", target: "#kontakt" },
];
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2F3338] px-6 py-16 text-[#FAF7F1] lg:py-20">
    <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-3">
      <div>
        <p className="font-serif text-2xl">Traumebevidst Udvikling</p>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FAF7F1]/70">
          Traumebevidst praksis, undervisning, supervision og organisatorisk udvikling.
        </p>
      </div>
      <nav aria-label="Footer navigation">
        <p className="text-xs font-medium tracking-[0.25em] text-[#D6C2A6]">NAVIGATION</p>
        <ul className="mt-6 space-y-3 text-sm">
          {NAV.map((item) => (
            <li key={item.label}>
              {item.to ? (
                <Link
                  to={item.to}
                  data-testid={`footer-nav-${slug(item.label)}`}
                  className="text-[#FAF7F1]/75 transition-colors duration-300 hover:text-[#D6C2A6]"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  href="#"
                  onClick={(e) => {
                    if (item.target) {
                      e.preventDefault();
                      scrollToSection(item.target);
                    }
                  }}
                  data-testid={`footer-nav-${slug(item.label)}`}
                  className="text-[#FAF7F1]/75 transition-colors duration-300 hover:text-[#D6C2A6]"
                >
                  {item.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <div>
        <p className="text-xs font-medium tracking-[0.25em] text-[#D6C2A6]">KONTAKT</p>
        <p className="mt-6 text-sm text-[#FAF7F1]/75">E-mail: kontakt@traumebevidstudvikling.dk</p>
        <p className="mt-3 text-sm text-[#FAF7F1]/75">CVR: 42608769</p>
      </div>
    </div>
    <div className="mx-auto mt-16 flex max-w-6xl flex-wrap items-center justify-between gap-4 border-t border-[#FAF7F1]/15 pt-7 text-xs text-[#FAF7F1]/55">
      <p>© 2026 Traumebevidst Udvikling</p>
      <div className="flex items-center gap-6">
        <button
          type="button"
          data-testid="footer-cookie-settings"
          onClick={openCookieSettings}
          className="transition-colors duration-300 hover:text-[#D6C2A6]"
        >
          Cookieindstillinger
        </button>
        <Link
          to="/privatlivspolitik"
          data-testid="footer-link-privatliv"
          className="transition-colors duration-300 hover:text-[#D6C2A6]"
        >
          Privatlivs- og cookiepolitik
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
